import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Table from 'components/Table'
import NewStudentsTableRow from 'modules/newStudents/components/NewStudentsTableRow'
import { isNilOrEmpty } from 'utils/ramda'
import styled from 'styled-components'
import Input from 'components/Input'
import SearchIcon from '@mui/icons-material/Search'
import { selectSchoolSubjects } from 'modules/settings/ducks/selectors'

const NewStudentsTable = ({ studentsList, actionCallback }) => {
  const schoolSubjects = useSelector(selectSchoolSubjects)
  const [filtered, setFiltered] = useState(studentsList)
  const [searchQuery, setSearchQuery] = useState('')

  useEffect(() => {
    const query = searchQuery.toLowerCase().trim()
    setFiltered(studentsList.filter(student => {
      const name = String(student.name || '').toLowerCase()
      const email = String(student.email || '').toLowerCase()
      const phone = String(student.phoneNumber || '').toLowerCase()
      const comment = String(student.comment || '').toLowerCase()
      const plannedRaw = student.plannedSubjects
      const plannedText =
        typeof plannedRaw === 'string'
          ? plannedRaw.toLowerCase()
          : Array.isArray(plannedRaw)
            ? plannedRaw
                .map(id => schoolSubjects.find(s => s.id === id)?.name || '')
                .join(' ')
                .toLowerCase()
            : ''
      return (
        name.includes(query) ||
        email.includes(query) ||
        phone.includes(query) ||
        comment.includes(query) ||
        plannedText.includes(query)
      )
    }))
  }, [searchQuery, studentsList, schoolSubjects])

  return (
    <>
      <InputWrapper>
        <Input
          name='search'
          placeholder='Szukaj...'
          onChange={(_, value) => setSearchQuery(value)}
          value={searchQuery}
          startAdornment={<SearchIcon />}
        />
      </InputWrapper>
      <Table>
        <thead>
          <tr>
            <th>Nazwa ucznia</th>
            <th>Plan. przedmioty</th>
            <th>Przedmiot</th>
            <th>Nauczyciel</th>
            <th>Dzień i godzina</th>
            <th>Komentarz</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {filtered.map(student => (
            <NewStudentsTableRow
              key={student.id}
              student={student}
              actionCallback={actionCallback}
              schoolSubjects={schoolSubjects}
            />
          ))}
        </tbody>
      </Table>
      {isNilOrEmpty(filtered) && (
        <EmptyState>Brak uczniów do wyświetlenia</EmptyState>
      )}
    </>
  )
}

export default NewStudentsTable

const InputWrapper = styled.div`
  display: flex;
  margin-bottom: 20px;

  div {
    max-width: 300px;
  }
`

const EmptyState = styled.div`
  width: 100%;
  padding: 40px;
  text-align: center;
  color: ${({ theme }) => theme.colors.darkGrey};
`
